import { createContext, useContext } from 'react';

type MyCardsContextType = {
  cardSets: {
    slug: string;
    name: string;
  }[];
};

export const MyCardsContext = createContext<MyCardsContextType>({
  cardSets: [],
});

export const useMyCardsContext = () => {
  return useContext(MyCardsContext);
};
